<template>
  <div>

    <CCReqDetail
      :loading="waiting"
      :requestedBy="coordinatedCoverageRequest.requestedBy"
      :employeeRequested="coordinatedCoverageRequest.employeeRequested"
      :request="coordinatedCoverageRequest.coordinatedCoverageRequest"
      :shift="coordinatedCoverageRequest.shift"
      :role="user.role"
      @accept="handleAccept"
      @reject="handleReject"
      @cancel="handleCancel"
    />

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CCReqDetail from '@/components/coordinated-coverage-requests/coordinated-coverage-request-detail.vue'

export default {
  components: {
    CCReqDetail,
  },
  created () {
    this.setUp()
  },
  watch: {
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
  },
  data: function () {
    return {
      waiting: true,
      coordinatedCoverageRequest: {}
    }
  },
  methods: {
    setUp () {
      const reqId = this.$route.params.coordinatedCoverageRequestId

      this.$store.dispatch('coordinatedCoverageRequests/get', reqId)
      .then(ccRequest => {
        this.coordinatedCoverageRequest = ccRequest
        this.waiting = false
      },
      error => {
        console.log(error)
      })
    },

    handleAccept: function() {
      this.waiting = true
      this.$store.dispatch('coordinatedCoverageRequests/accept', this.coordinatedCoverageRequest.coordinatedCoverageRequest.id)
      .then(ccRequest => {
        this.coordinatedCoverageRequest = ccRequest
        this.waiting = false
      },
      error => {
        // a custom message from the server
        if (error.response.status == 400) {
          let message = `Cannot accept this request: ${ error.response.data.message }`
          alert(message)
        } else {
          // something else unexpected
          console.log(error)
        }
        this.waiting = false
      })
    },

    handleReject: function() {
      this.waiting = true
      this.$store.dispatch('coordinatedCoverageRequests/reject', this.coordinatedCoverageRequest.coordinatedCoverageRequest.id)
      .then(ccRequest => {
        this.coordinatedCoverageRequest = ccRequest
        this.waiting = false
      },
      error => {
        console.log(error)
        this.waiting = false
      })
    },

    handleCancel: function() {
      this.waiting = true
      this.$store.dispatch('coordinatedCoverageRequests/cancel', this.coordinatedCoverageRequest.coordinatedCoverageRequest.id)
      .then(ccRequest => {
        this.coordinatedCoverageRequest = ccRequest
        this.waiting = false
      },
      error => {
        console.log(error)
        this.waiting = false
      })
    }
  }
}
</script>

<style scoped>
</style>
